export const styles = {
  root: 'gap-sm md:gap-md',
  description: 'md:text-md',
  backButton: 'absolute left-0 bottom-full self-start',
};
